function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "hideDescendantCount"
];
import * as React from 'react';
import { gridRowTreeSelector, useFirstRender, GRID_CHECKBOX_SELECTION_FIELD } from '@mui/x-data-grid';
import { useGridRegisterPipeProcessor, useGridRegisterStrategyProcessor } from '@mui/x-data-grid/internals';
import { GRID_TREE_DATA_GROUPING_COL_DEF, GRID_TREE_DATA_GROUPING_COL_DEF_FORCED_PROPERTIES } from "../treeData/gridTreeDataGroupColDef.js";
import { skipFiltering, skipSorting } from "./utils.js";
import { GridDataSourceTreeDataGroupingCell } from "../../../components/GridDataSourceTreeDataGroupingCell.js";
import { createRowTree } from "../../../utils/tree/createRowTree.js";
import { updateRowTree } from "../../../utils/tree/updateRowTree.js";
import { getVisibleRowsLookup } from "../../../utils/tree/utils.js";
import { TreeDataStrategy } from "../treeData/gridTreeDataUtils.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var useGridDataSourceTreeDataPreProcessors = function(privateApiRef, props) {
    var setStrategyAvailability = React.useCallback(function() {
        privateApiRef.current.setStrategyAvailability('rowTree', TreeDataStrategy.DataSource, props.treeData && props.unstable_dataSource ? function() {
            return true;
        } : function() {
            return false;
        });
    }, [
        privateApiRef,
        props.treeData,
        props.unstable_dataSource
    ]);
    var getGroupingColDef = React.useCallback(function() {
        var groupingColDefProp = props.groupingColDef;
        var colDefOverride;
        if (typeof groupingColDefProp === 'function') {
            var params = {
                groupingName: TreeDataStrategy.DataSource,
                fields: []
            };
            colDefOverride = groupingColDefProp(params);
        } else {
            colDefOverride = groupingColDefProp;
        }
        var _ref = colDefOverride !== null && colDefOverride !== void 0 ? colDefOverride : {}, hideDescendantCount = _ref.hideDescendantCount, colDefOverrideProperties = _objectWithoutPropertiesLoose(_ref, _excluded);
        var commonProperties = _extends({}, GRID_TREE_DATA_GROUPING_COL_DEF, {
            renderCell: function(params) {
                return /*#__PURE__*/ _jsx(GridDataSourceTreeDataGroupingCell, _extends({}, params, {
                    hideDescendantCount: hideDescendantCount
                }));
            },
            headerName: privateApiRef.current.getLocaleText('treeDataGroupingHeaderName')
        });
        return _extends({}, commonProperties, colDefOverrideProperties, GRID_TREE_DATA_GROUPING_COL_DEF_FORCED_PROPERTIES);
    }, [
        privateApiRef,
        props.groupingColDef
    ]);
    var updateGroupingColumn = React.useCallback(function(columnsState) {
        if (!props.unstable_dataSource) {
            return columnsState;
        }
        var groupingColDefField = GRID_TREE_DATA_GROUPING_COL_DEF_FORCED_PROPERTIES.field;
        var shouldHaveGroupingColumn = props.treeData;
        var prevGroupingColumn = columnsState.lookup[groupingColDefField];
        if (shouldHaveGroupingColumn) {
            var newGroupingColumn = getGroupingColDef();
            if (prevGroupingColumn) {
                newGroupingColumn.width = prevGroupingColumn.width;
                newGroupingColumn.flex = prevGroupingColumn.flex;
            }
            columnsState.lookup[groupingColDefField] = newGroupingColumn;
            if (prevGroupingColumn == null) {
                var index = columnsState.orderedFields[0] === GRID_CHECKBOX_SELECTION_FIELD ? 1 : 0;
                columnsState.orderedFields = _to_consumable_array(columnsState.orderedFields.slice(0, index)).concat([
                    groupingColDefField
                ], _to_consumable_array(columnsState.orderedFields.slice(index)));
            }
        } else if (!shouldHaveGroupingColumn && prevGroupingColumn) {
            delete columnsState.lookup[groupingColDefField];
            columnsState.orderedFields = columnsState.orderedFields.filter(function(field) {
                return field !== groupingColDefField;
            });
        }
        return columnsState;
    }, [
        props.treeData,
        props.unstable_dataSource,
        getGroupingColDef
    ]);
    var createRowTreeForTreeData = React.useCallback(function(params) {
        var _props_unstable_dataSource, _props_unstable_dataSource1;
        var getGroupKey = (_props_unstable_dataSource = props.unstable_dataSource) === null || _props_unstable_dataSource === void 0 ? void 0 : _props_unstable_dataSource.getGroupKey;
        if (!getGroupKey) {
            throw new Error('MUI X: No `getGroupKey` method provided with the dataSource.');
        }
        var getChildrenCount = (_props_unstable_dataSource1 = props.unstable_dataSource) === null || _props_unstable_dataSource1 === void 0 ? void 0 : _props_unstable_dataSource1.getChildrenCount;
        if (!getChildrenCount) {
            throw new Error('MUI X: No `getChildrenCount` method provided with the dataSource.');
        }
        var _params_updates_groupKeys;
        var parentPath = (_params_updates_groupKeys = params.updates.groupKeys) !== null && _params_updates_groupKeys !== void 0 ? _params_updates_groupKeys : [];
        var getRowTreeBuilderNode = function(rowId) {
            var count = getChildrenCount(params.dataRowIdToModelLookup[rowId]);
            return {
                id: rowId,
                path: _to_consumable_array(parentPath).concat([
                    getGroupKey(params.dataRowIdToModelLookup[rowId])
                ]).map(function(key) {
                    return {
                        key: key,
                        field: null
                    };
                }),
                serverChildrenCount: count
            };
        };
        var onDuplicatePath = function(firstId, secondId, path) {
            throw new Error([
                'MUI X: The values returned by `getGroupKey` for all the sibling rows should be unique.',
                "The rows with id #".concat(firstId, " and #").concat(secondId, " have the same."),
                "Path: ".concat(JSON.stringify(path.map(function(step) {
                    return step.key;
                })), ".")
            ].join('\n'));
        };
        if (params.updates.type === 'full') {
            return createRowTree({
                previousTree: params.previousTree,
                nodes: params.updates.rows.map(getRowTreeBuilderNode),
                defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
                isGroupExpandedByDefault: props.isGroupExpandedByDefault,
                groupingName: TreeDataStrategy.DataSource,
                onDuplicatePath: onDuplicatePath
            });
        }
        return updateRowTree({
            nodes: {
                inserted: params.updates.actions.insert.map(getRowTreeBuilderNode),
                modified: params.updates.actions.modify.map(getRowTreeBuilderNode),
                removed: params.updates.actions.remove
            },
            previousTree: params.previousTree,
            previousGroupsToFetch: params.previousGroupsToFetch,
            previousTreeDepth: params.previousTreeDepths,
            defaultGroupingExpansionDepth: props.defaultGroupingExpansionDepth,
            isGroupExpandedByDefault: props.isGroupExpandedByDefault,
            groupingName: TreeDataStrategy.DataSource
        });
    }, [
        props.unstable_dataSource,
        props.defaultGroupingExpansionDepth,
        props.isGroupExpandedByDefault
    ]);
    var filterRows = React.useCallback(function() {
        var rowTree = gridRowTreeSelector(privateApiRef);
        return skipFiltering(rowTree);
    }, [
        privateApiRef
    ]);
    var sortRows = React.useCallback(function() {
        var rowTree = gridRowTreeSelector(privateApiRef);
        return skipSorting(rowTree);
    }, [
        privateApiRef
    ]);
    useGridRegisterPipeProcessor(privateApiRef, 'hydrateColumns', updateGroupingColumn);
    useGridRegisterStrategyProcessor(privateApiRef, TreeDataStrategy.DataSource, 'rowTreeCreation', createRowTreeForTreeData);
    useGridRegisterStrategyProcessor(privateApiRef, TreeDataStrategy.DataSource, 'filtering', filterRows);
    useGridRegisterStrategyProcessor(privateApiRef, TreeDataStrategy.DataSource, 'sorting', sortRows);
    useGridRegisterStrategyProcessor(privateApiRef, TreeDataStrategy.DataSource, 'visibleRowsLookupCreation', getVisibleRowsLookup);
    /**
   * 1ST RENDER
   */ useFirstRender(function() {
        setStrategyAvailability();
    });
    /**
   * EFFECTS
   */ var isFirstRender = React.useRef(true);
    React.useEffect(function() {
        if (!isFirstRender.current) {
            setStrategyAvailability();
        } else {
            isFirstRender.current = false;
        }
    }, [
        setStrategyAvailability
    ]);
};
